// extracted by mini-css-extract-plugin
export default {"container":"p4GuQc","containerBackButton":"dwzuSU","loadingScreen":"iNy3ED"};